import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { FilterOpts } from "@saleor/types";
import {
  CommentParentTypeEnum,
  CommentSourceTypeEnum
} from "@saleor/types/globalTypes";
import {
  createBooleanField,
  // createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";
export enum InsCommentFilterKeys {
  isVisible = "isVisible",
  source = "source",
  parentType = "parentType"
}

export interface InsCommentListFilterOpts {
  isVisible: FilterOpts<boolean>;
  parentType: FilterOpts<CommentParentTypeEnum[]>;
  source: FilterOpts<CommentSourceTypeEnum[]>;
}

const messages = defineMessages({
  isVisible: {
    defaultMessage: "isVisible",
    description: "ins_comment"
  },
  parentType: {
    defaultMessage: "Parent Type",
    description: "ins_comment"
  },
  source: {
    defaultMessage: "Source Type",
    description: "ins_comment"
  }
});

const sourceMessages = defineMessages({
  ins: {
    defaultMessage: "Instagram",
    description: "ins_comment"
  },
  tt: {
    defaultMessage: "TikTok",
    description: "ins_comment"
  },
  space: {
    defaultMessage: "Space",
    description: "ins_comment"
  }
});

const parentTypeMessages = defineMessages({
  ins: {
    defaultMessage: "Instagram",
    description: "ins_comment"
  },
  tt: {
    defaultMessage: "TikTok",
    description: "ins_comment"
  },
  comment: {
    defaultMessage: "Comment",
    description: "ins_comment"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: InsCommentListFilterOpts
): IFilter<InsCommentFilterKeys> {
  return [
    {
      ...createOptionsField(
        InsCommentFilterKeys.parentType,
        intl.formatMessage(messages.parentType),
        opts.parentType.value,
        true,
        [
          {
            label: intl.formatMessage(parentTypeMessages.ins),
            value: CommentParentTypeEnum.INSTAGRAM
          },
          {
            label: intl.formatMessage(parentTypeMessages.tt),
            value: CommentParentTypeEnum.TIKTOK
          },
          {
            label: intl.formatMessage(parentTypeMessages.comment),
            value: CommentParentTypeEnum.COMMENT
          }
        ]
      ),
      active: opts.parentType.active
    },
    {
      ...createOptionsField(
        InsCommentFilterKeys.source,
        intl.formatMessage(messages.source),
        opts.source.value,
        true,
        [
          {
            label: intl.formatMessage(sourceMessages.ins),
            value: CommentSourceTypeEnum.INSTAGRAM
          },
          {
            label: intl.formatMessage(sourceMessages.tt),
            value: CommentSourceTypeEnum.TIKTOK
          },
          {
            label: intl.formatMessage(sourceMessages.space),
            value: CommentSourceTypeEnum.SPACE
          }
        ]
      ),
      active: opts.source.active
    },
    {
      ...createBooleanField(
        InsCommentFilterKeys.isVisible,
        intl.formatMessage(messages.isVisible),
        opts.isVisible.value,
        {
          negative: intl.formatMessage(commonMessages.no),
          positive: intl.formatMessage(commonMessages.yes)
        }
      ),
      active: opts.isVisible.active
    }
  ];
}
